export default {
  DEMIS_COMPANY_TERMS_URL: 'https://www.demis.ru/company/terms/',
  NEWS_URL: 'https://news.demis.ru/api/news',
  STOCKS_URL: 'https://news.demis.ru/api/stocks',
  AUTH_URL: 'https://ca.demis.ru/',
  SERVICE_CONTEXT: 'Context',
  SERVICE_SERM: 'SERM',
  SERVICE_TECH_SUPPORT: 'TechSupport',
  SERVICE_SMM: 'SMM',
  SERVICE_SEO: 'SEO',
  SERVICE_UX: 'UX',
  SENGINE_YANDEX: 'y',
  SENGINE_GOOGLE: 'g',
  FORM_CALL_ORDER_MODAL_ID: 'call-order',
  FORM_ACCESS_MODAL_ID: 'access',
  FORM_SOS_MODAL_ID: 'sos',
  UPLOAD_MAX_FILES_SIZE: 1024 * 1024 * 30, // 30 MB
  FORM_MAIL_ORDER_MODAL_ID: 'mail-order',
  FORM_QUALITY_SERVICE_MODAL_ID: 'quality-service',
  INTERVIEW_MODAL_ID: 'interview',
  DOCUMENTS_ORDER_MODAL_ID: 'documents-order',
  PRIVILEGE_ORDER_MODAL_ID: 'privilege-order',
  SERVICE_ORDER_MODAL_ID: 'service-order',
  AGREEMENTS_EXISTS_MODAL_ID: 'agreements-exists',
  NO_MONEY_MODAL_ID: 'no-money',
  SEO_GOOD_NEWS_MODAL_ID: 'seo-good-news',
  LOYALTY_STATUS_BRONZE: 'bronze',
  LOYALTY_STATUS_SILVER: 'silver',
  LOYALTY_STATUS_GOLD: 'gold',
  LOYALTY_STATUS_PLATINUM: 'platinum',
  PHONE_INPUT_MASK: '+9(999)999-99-99',
  DATE_INPUT_MASK: '99-99-9999',
  DATE_INPUT_FORMAT: 'DD-MM-YYYY',
  METRICS_VISITS: 'visits',
  METRICS_SOURCES: 'sources',
  METRICS_GEO: 'geo',
  METRICS_TARGETS: 'targets',
  METRICS_DEVICES: 'devices',
  PRIVILEGE_TYPE_DISCOUNT: 'discount',
  PRIVILEGE_TYPE_SERVICE: 'service',
  NOTIFICATION_PLACEMENT: 'bottom-right'
}
